import { StyleSheet, type TextStyle } from 'react-native';
import theme from '../../../common/theme';

const textStyle: TextStyle = {
  fontSize: 14,
  lineHeight: 20,
  fontVariant: ['tabular-nums'],
  fontFamily: theme.fonts.medium,
  color: theme.palette.mono800,
};

export const styles = StyleSheet.create({
  container: {
    width: 600,
    alignSelf: 'center',
  },
  content: {
    padding: 30,
    marginTop: 8,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.white,
    ...theme.shadow.strong,
  },
  message: {
    padding: 12,
    marginBottom: 10,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.orangeLightest,
  },
  messageText: {
    ...textStyle,
    textAlign: 'center',
    color: theme.palette.orangeDark,
    fontFamily: theme.fonts.regular,
  },
  list: {
    maxHeight: 400,
  },
  empty: {
    height: 200,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.mono100,
  },
  emptyText: {
    ...textStyle,
    color: theme.palette.mono600,
  },
  rows: {
    rowGap: 8,
  },
  actions: {
    marginTop: 30,
    flexDirection: 'row',
    columnGap: 10,
    justifyContent: 'flex-end',
  },
  btn: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.blueLight,
  },
  btnText: {
    ...textStyle,
    color: theme.palette.blue,
  },
});
